import { Component, OnInit, ViewEncapsulation } from '@angular/core';
@Component({
  selector: 'app-language-page',
  templateUrl: './language-page.component.html',
  styleUrls: ['./language-page.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LanguageComponent implements OnInit {
  ngOnInit(): void {
  }
}